import { createContext } from "react";

export const UiPicklistContext = createContext();
